module.exports = __webpack_public_path__ + "static/media/05.a63c43e3.jpg";